<!--
  - Copyright (c) 2020.
  - Project: Source
  - LastModified: 2/14/20, 3:24 PM
  - Author: diengv < Giáp Văn Điện >
  - Email: diengv@ominext.com
  - File name: Logo.vue
  - File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/components/Logo.vue
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128.91 90" :height="height">
    <title v-if="title">{{title}}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path class="cls-1" :fill="color[0]"
              d="M18.61,59.05l-2.75-1.19A74.91,74.91,0,0,0,48,76c-12.49-5.79-21-12-26.91-17.82ZM28,55.56l-2.39.92a101.2,101.2,0,0,0,15,9.64C35.7,62.27,31.56,58.78,28,55.56Zm-17.72-.18-3-1.29,1.47-.82c-5-7.44-5.79-12.59-5.79-12.59a65.55,65.55,0,0,0,7.72,11.48l3.67-2c-5.42-7.71-6-13.22-6-13.22a51.26,51.26,0,0,0,8.54,11.85l2.85-1.57c-23.61-27.55,4.5-34.62,4.5-34.62C6.58,16.44-5.72,33.61,2.73,49.87S27.25,71.82,27.25,71.82A79.08,79.08,0,0,1,10.26,55.38Zm94.31,3c5.06,18.92-44-6.34-44-6.34,58,26.73,38.94-3.86,38.94-3.86,10.93,26.36-33.33,1.29-36.09-.27v1.47l-9.55,3.67c13.87,7.26,24,11.48,31.41,13.59,1.93.55,3.76,1,5.32,1.29C109.26,71.54,104.57,58.41,104.57,58.41ZM96.22,45.09a29.24,29.24,0,0,0-1.56-2.75c.64,1.1,1.1,2.11,1.56,3,3,6.61,2.11,9.46-.92,10a15.39,15.39,0,0,1-6.61-.92c-9.1-2.85-22-10.93-25.26-13v6.43C104.57,68.14,99.61,52,96.22,45.09Z"/>
        <path class="cls-2" :fill="color[1]"
              d="M94.75,42.34a29.24,29.24,0,0,1,1.56,2.75,43.17,43.17,0,0,0-3-14.51l35.63-11.85L111.28,0,83.91,16.16a43.64,43.64,0,0,0-68,7A41.2,41.2,0,0,1,47.73,8.27,40.72,40.72,0,0,1,76.84,20.39L60.77,29.85,46.72,23.6V43.71L32.48,50.14h-.92v-18l10.38-7.8L30.28,31.68v9.55L19.81,47,17,48.58l-2.57,1.47-3.67,2-1.93,1.1L7.32,54l3,1.29L16,57.77,18.8,59,21.28,58l4.5-1.65,2.39-.92L37.72,52l9.73,3.58L54,53.08l9.55-3.67V40.5l22.23-7.35a40.76,40.76,0,0,1,3.4,16.35,45.81,45.81,0,0,1-.28,5,15.55,15.55,0,0,0,6.61.92,46.44,46.44,0,0,0,.92-8.82V45.37Q95.57,44,94.75,42.34ZM63.43,40h0l-3.21,1.28-5.33,2.12.83-.28-1.29.46V33.34l1.65-.74-.82.46,4-1.93,2.2-1h-.09L110.08,7,121,17.54ZM55.81,90a43.4,43.4,0,0,0,34.8-22,53.6,53.6,0,0,1-5.32-1.28A41.83,41.83,0,0,1,55.81,90Z"/>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'logo',
    props: {
      title: {
        type: String,
        default: ''
      },
      color: {
        type: Array,
        default: () => ['#ab5153', '#395d76']
      },
      height: {
        type: String,
        default: null
      }
    }
  }
</script>

<style>

</style>
